import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login, accountResetPassword } from '../../../../actions/authenticationActions';
import { ROUTE_LOGIN_EMAIL } from '../../../../constants/Routes';
import BackToLogin from '../../../common/links/BackToLogin';

import PasswordSent from './PasswordSent';

@connect(
	({ authentication }) => ({
		email: authentication.email,
	}),
	{ login, accountResetPassword }
)
export default class PasswordSentContainer extends Component {
	static propTypes = {
		email: PropTypes.string.isRequired,
		history: PropTypes.object.isRequired,
	};

	componentDidMount() {
		const { email, history } = this.props;
		if (!email) {
			history.push(ROUTE_LOGIN_EMAIL);
		}
	}

	render() {
		return (
			<>
				<PasswordSent
					email={this.props.email}
					accountResetPassword={this.props.accountResetPassword}
				/>
				<BackToLogin />
			</>
		);
	}
}
